import classNames from 'classnames';

const addClassName = (name: string) => {
  return { [`${name}`]: true };
};

/**
 * Add an array of classNames to a JSX element.
 * Also adds an optional className from component props if not undefined.
 *
 * @param names string[]
 * @param className string | undefined
 * @returns string
 */
export const addClassNames = (names: string[], className?: string): string => {
  return classNames({
    ...names.map((name) => addClassName(name)),
    [`${className}`]: !!className
  });
};
